import React from "react"
import { motion } from 'framer-motion'

const Footer = () => {
    return (<motion.div className="w-full py-6 px-4 text-center text-sm sm:text-base md:text-lg font-bold flex flex-col sm:flex-row items-center justify-center gap-2">
        <span>© 2025 Royal Kavery Matrimony | Developed & Maintained by&nbsp;</span>
        <span className="text-primeColor text-base sm:text-lg font-bold">
            <a href="https://solvintel.com" target="__blank" rel="noopener noreferrer">Solvintel</a>
        </span>
    </motion.div>)
}

export default Footer